import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";

import { Column } from "@rui/Stack";

import RecapSettingsContent from "./RecapSettingsContent";

const RecapSettingsDialog = () => {
  return (
    <MobileDialog id="recap_settings" title="Settings">
      <Column spacing={0.5}>
        <RecapSettingsContent />
      </Column>
    </MobileDialog>
  );
};

export default RecapSettingsDialog;
